import { InjectionToken } from '@angular/core';
import { PlayerDetailsResolver } from './player-details';

export interface PlayerComponentConfig {
  /**
   * Takes a bbUserName, returns a value that can be passed to RouterLink to link to the player profile for that player,
   * or undefined if no player profile link is available
   * @param bbUserName
   */
  profileLink: (bbUserName: string) => string | unknown[] | undefined;
  detailsResolver: PlayerDetailsResolver;
}

export const PLAYER_COMPONENT_CONFIG =
  new InjectionToken<PlayerComponentConfig>('PlayerComponentConfig');
